import React, { useCallback } from 'react';
import 'pages/DogDetail/DogDetail.css';
import Button from 'components/Button/Button';
import DogCarousel from 'pages/DogDetail/DogCarousel/DogCarousel';
import DogCard from 'components/DogCard/DogCard';
import { useHistory, useParams } from 'react-router-dom';
import useDogDetails from 'pages/DogDetail/hooks/useDogDetails';

import moment from 'moment';
import useSuggestionsDogsData from 'pages/DogDetail/hooks/useSuggestionsDogsData';
import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import { useModal } from 'modules/Modal/ModalProvider';

function DogDetail() {
    const { dogId } = useParams();
    const [dogData, loading] = useDogDetails(dogId);
    const [dogSuggestionsData] = useSuggestionsDogsData(dogId);
    const { storage } = useFirebaseProviders();
    const { openReservationFormModal } = useModal();
    const history = useHistory();

    const openAgreement = useCallback(async () => {
        const downloadUrl = await storage.child('sharedDocs/agreement.pdf').getDownloadURL();
        const newTab = window.open(downloadUrl, '_blank');
        if (newTab) newTab.focus();
    }, [storage]);

    const book = useCallback(() => {
        if (!dogData) return;
        openReservationFormModal(dogId, dogData);
    }, [dogData, dogId, openReservationFormModal]);

    const dogCardClickHandler = useCallback(
        id => {
            history.push(id);
        },
        [history]
    );

    console.log(dogData)

    if (loading) return <section className={'dog-detail'} />;

    return (
        <section className={'dog-detail background-gradient'}>
            <div className={'dog-detail-wrapper'}>
                <div className={'dog-detail-content shadow'}>
                    <div>
                        <DogDetailRow field={'Name'} value={dogData.name} />
                        <DogDetailRow
                            field={'Age'}
                            value={moment(dogData?.birthday).toNow(true)}
                        />
                        <DogDetailRow field={'Gender'} value={dogData.gender} />
                        <h3>ALL OUR PARENTS DOGS ARE FROM AKC CHAMPION BLOODLINE.</h3>
                        <p>Inquiries about our puppy can be made by text message <a href="sms:6053877878">(605)660-7878</a>, phone <a href="tel:6053875250">(605)387-5250</a>, FB messenger, or email <a href="mailto:mypianobabe@yahoo.com">mypianobabe@yahoo.com</a></p>
                        <p>{dogData.description}</p>
                        {!!dogData.isForSale && !!dogData.price && <DogDetailRow field={'Price'} value={`$ ${dogData.price}`}/>}
                    </div>
                    {dogData.isForSale && <div className={'dog-detail__controls'}>
                        <Button label={'Reserve'} secondary onClick={book}/>
                        <Button label={'View Agreement'} secondary onClick={openAgreement}/>
                    </div>}
                </div>
                <DogCarousel dogId={dogId} />
            </div>
            {dogData.certUrl && <img className={'dog-detail__cert shadow'} src={dogData.certUrl}/>}
            <div className={'dog-detail-suggestions'}>
                {dogSuggestionsData?.docs?.map(dogRef => (
                    <DogCard
                        dogRef={dogRef}
                        id={dogRef.id}
                        key={dogRef.id}
                        onClick={dogCardClickHandler}
                    />
                ))}
            </div>
        </section>
    );
}

export default DogDetail;

function DogDetailRow({ field, value }) {
    return (
        <div className={'dog-detail-row'}>
            {field && <div className={'dog-detail-row__field'}>{field}:</div>}
            <div className={'dog-detail-row__value'}>{value}</div>
        </div>
    );
}

const preDescriptionText = 'ALL OUR PARENTS DOGS ARE FROM AKC CHAMPION BLOODLINE. Inquiries about our puppy can be made by text message 605-660-7878, phone 605-387-5250, FB messenger, or email mypianobabe@yahoo.com'
